import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CommonUtil } from '../../../utils/CommonUtil';
import { Constants } from '../../Languages/Constants';
import SingleSelectComp from '../../../Components/SingleSelectComp';
import InputField from '../../../Components/InputField';
import SelectField from '../../../Components/SelectField';
import { NetworkManager } from '../../../Components/NetworkManager';

const AddNewReleaseForm = ({show, onSubmit, data}: any) => {
  const [carriers, setCareers] = useState([]);
  const [brokers, setBrokers] = useState([]);

  let onLoginError = (err: any) => {
    console.log(err);
  };

  useEffect(() => {
    if (show && data) {
      formik.setValues({
        driverName: data.driverName || '',
        truckNumber: data.truckNumber || '',
        loadStatus: data.loadStatus || '',
        manifestNumber: data.manifestNumber || '',
        brokerId: data.brokerId || null,
        brokerName: data.brokerName || '',
        otherBroker: data.otherBroker || '',
        carrierId: data.carrierId || null,
        carrierName: data.carrierName || '',
        otherCarrier: data.otherCarrier || '',
        driverPhoneNumber: data.driverPhoneNumber || '',
        sealNumber: data.sealNumber || '',
      });
    }
  }, [show, data]);


  useEffect(() => {
    if(show){
      getCareerList();
      getBrokerList();
    }
  },[show]);

  const getCareerList = () => {
    var orgUrl = `api/webInspectionDetails/carriers?saasOrgId=${CommonUtil.getSaasOrgId()}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, (dataObj: any) => {
      if (dataObj) {
        var restData = JSON.parse(dataObj);
        if (restData){
          const data = restData?.map((item: any) => ({
            label: item?.carrierName,
            value: item?.carrierName
          }));
          setCareers(data);
          }
      }
    }, onLoginError);
  };

  const getBrokerList = () => {
    var orgUrl = `api/webInspectionDetails/brokers?saasOrgId=${CommonUtil.getSaasOrgId()}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, (dataObj: any) => {
      if (dataObj) {
        var restData = JSON.parse(dataObj);
        if (restData){
          const data = restData?.map((item: any) => ({
            label: item?.brokerName,
            value: item?.brokerName
          }));
          setBrokers(data);
        }
      }
    }, onLoginError);
  };

  const validationSchema = Yup.object({
    driverName: Yup.string().required('Driver Name is required'),
    truckNumber: Yup.string().required('Truck Number is required'),
    loadStatus: Yup.string().required('Load Status is required'),
    manifestNumber: Yup.string().required('Manifest/Order is required'),
    brokerId: Yup.number().nullable(),
    // otherBroker: Yup.string().when('brokerName', {
    //   is: 'Others',
    //   then: Yup.string().required('Other Broker Name is required'),
    //   otherwise: Yup.string().nullable()
    // }),
    carrierId: Yup.number().nullable(),
    // otherCarrier: Yup.string().when('carrierName', {
    //   is: 'Others',
    //   then: Yup.string().required('Other Carrier Name is required'),
    //   otherwise: Yup.string().nullable()
    // }),
    driverPhoneNumber: Yup.string()
      .required('Phone number is required')
      .min(10, 'Enter a valid phone number'),
    sealNumber: Yup.string().required('Seal Number is required'),
  });

  const formik = useFormik({
    initialValues: {
      driverName: '',
      truckNumber: '',
      loadStatus: '',
      manifestNumber: '',
      brokerId: null,
      brokerName: '',
      otherBroker: '',
      carrierId: null,
      carrierName: '',
      otherCarrier: '',
      driverPhoneNumber: '',
      sealNumber: '',
    },
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="modal-body py-3">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 mb-3">
              <InputField
                  type="text"
                  name="driverName"
                  placeholder="Driver Name"
                  value={formik.values.driverName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
              />
              {formik.touched.driverName && formik.errors.driverName && (
                <small className="text-danger">{formik.errors.driverName}</small>
              )}
            </div>
            <div className="col-lg-12 mb-3">
              <InputField
                type="text"
                name="truckNumber"
                placeholder="Truck Number"
                value={formik.values.truckNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.truckNumber && formik.errors.truckNumber && (
                <small className="text-danger">{formik.errors.truckNumber}</small>
              )}
            </div>
            <div className="col-lg-12 mt-2 mb-3">
              <SelectField
                name="loadStatus"
                placeholder="Load Status"
                onChange={formik.handleChange}
                value={formik.values.loadStatus}
                onBlur={formik.handleBlur}
              >
                <option value="" disabled>Select</option>
                <option value="Loaded">Loaded</option>
                <option value="Unloaded">Unloaded</option>
            </SelectField>
              {formik.touched.loadStatus && formik.errors.loadStatus && (
                <small className="text-danger">{formik.errors.loadStatus}</small>
              )}
            </div>
            <div className="col-lg-12 mb-3">
              <InputField
                type="text"
                name="manifestNumber"
                className="form-control"
                placeholder="Manifest/Order"
                value={formik.values.manifestNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.manifestNumber && formik.errors.manifestNumber && (
                <small className="text-danger">{formik.errors.manifestNumber}</small>
              )}
            </div>
            <div className="col-lg-12 mb-4">
              <SelectField
                name="brokerName"
                placeholder="Broker Name"
                onChange={formik.handleChange}
                value={formik.values.brokerName}
                onBlur={formik.handleBlur}
              >
                <option value="" disabled>Select</option>
                {brokers?.map((item: any, i: any)=>(
                  <option value={item.value} key={i} >{item?.label}</option>
                ))}
            </SelectField>
              {formik.values.brokerName === 'Others' && (
                <InputField
                  type="text"
                  className="form-control mt-4"
                  name="otherBroker"
                  value={formik.values.otherBroker}
                  placeholder="Other Broker"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              )}
              {formik.touched.otherBroker && formik.errors.otherBroker && (
                <small className="text-danger">{formik.errors.otherBroker}</small>
              )}
            </div>

            {/* Carrier */}
            <div className="col-lg-12 mb-3">
              <SelectField
                name="carrierName"
                placeholder="Carrier Name"
                onChange={formik.handleChange}
                value={formik.values.carrierName}
                onBlur={formik.handleBlur}
              >
                <option value="" disabled>Select</option>
                {carriers?.map((item: any, i: any)=>(
                  <option value={item.value} key={i} >{item?.label}</option>
                ))}
              </SelectField>
              {formik.values.carrierName === 'Others' && (
                <InputField
                  type="text"
                  className="form-control mt-4"
                  name="otherCarrier"
                  value={formik.values.otherCarrier}
                  placeholder="Other Carrier"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              )}
              {formik.touched.otherCarrier && formik.errors.otherCarrier && (
                <small className="text-danger">{formik.errors.otherCarrier}</small>
              )}
            </div>
            <div className="col-lg-12 mb-3">
              <div className="d-flex cust-phone-input">
                {<div className='phone-input'> +1</div>}
              <InputField 
                type="tel"
                name="driverPhoneNumber"
                style={{ width: "100%", borderLeft: "0px", }}
                value={formik.values.driverPhoneNumber}
                onChange={(e:any) => formik.setFieldValue("driverPhoneNumber", e.target.value.replace(/\D/g, ''))}
                onBlur={() => formik.setFieldTouched("driverPhoneNumber", true)}
                placeholder={CommonUtil.getMessageText(Constants.PHONE_NO, 'Phone Number')}
              />
              </div>
              {formik.touched.driverPhoneNumber && formik.errors.driverPhoneNumber && (
                <small className="text-danger">{formik.errors.driverPhoneNumber}</small>
              )}
            </div>

            <div className="col-lg-12 mb-3">
              <InputField
                type="number"
                name="sealNumber"
                placeholder="Enter Seal Number"
                value={formik.values.sealNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.sealNumber && formik.errors.sealNumber && (
                <small className="text-danger">{formik.errors.sealNumber}</small>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal-footer">
          <>
            <button
              type="button"
              className="btn btn-outline-dark me-2"
              onClick={() => {
                // closeModal();
                formik.resetForm();
              }}
            >
              {CommonUtil.getMessageText(Constants.CANCEL, 'Cancel')}
            </button>
            <button type="submit" className="btn-green">
              Save and Proceed
            </button>
          </>
      </div>
    </form>
  );
};

export default AddNewReleaseForm;
